import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { css } from 'styled-components';

var _templateObject;
const reachTabStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  /** Removes warning for styles */\n  :root {\n    --reach-tabs: 1;\n  }\n"])));

export { reachTabStyles };
